import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { CompassButtonModule } from '@pwc/compass/button';
import { CompassIconModule } from '@pwc/compass/icon';

@Component({
  selector: 'esp-back-to',
  imports: [CommonModule, CompassButtonModule, CompassIconModule],
  template: `
    <button mat-button compass-button-plain>
      <mat-icon compassIcon="arrow_left"></mat-icon>
      @if (whereLabel()) {
        Back to {{ whereLabel() }}
      } @else {
        Back
      }
    </button>
  `,
})
export class BackToComponent {
  whereLabel = input('');
}
